export default {
  parent: "train",
  routers: [
    // 培训
    {
      path: "index",
      name: "trainIndex",
      component: () => import("@/views/train/indexView.vue"),
      // redirect: { name: "MyDiary" },
      // meta: { title: "培训" },
    },
    // 学习
    {
      path: "study",
      name: "study",
      component: () => import("@/views/train/study/tabView.vue"),
      // redirect: { name: "MyDiary" },
      // meta: { title: "学习" },
    },
    // 课程
    {
      path: "course",
      name: "course",
      component: () => import("@/views/train/course/indexView.vue"),
      // redirect: { name: "MyDiary" },
      meta: { title: "课程" },
    },
    // 直播
    {
      path: "live",
      name: "live",
      component: () => import("@/views/train/live/indexView.vue"),
      meta: { title: "直播" },
    },
    // 班级
    {
      path: "class",
      name: "class",
      component: () => import("@/views/train/class/tabView.vue"),
      // redirect: { name: "MyDiary" },
      meta: { title: "班级" },
    },
    // **************************************************************************学员
    // 学员
    {
      path: "student",
      name: "student",
      component: () => import("@/views/train/student/indexView.vue"),
      meta: { title: "学员" },
    },
    // **************************************************************************讲师
    // 讲师
    {
      path: "lecturer",
      name: "lecturer",
      component: () => import("@/views/train/lecturer/tabView.vue"),
      // redirect: { name: "MyDiary" },
      // meta: { title: "讲师" },
    },
    // **************************************************************************测验
    // 考试
    {
      path: "exam",
      name: "exam",
      component: () => import("@/views/train/exam/examination.vue"),
      // redirect: { name: "MyDiary" },
      meta: { title: "考试" },
    },
    // 评估
    {
      path: "assess",
      name: "assess",
      component: () => import("@/views/train/exam/estimate.vue"),
      // redirect: { name: "MyDiary" },
      meta: { title: "评估" },
    },
    // 商城
    {
      path: "mall",
      name: "mall",
      component: () => import("@/views/train/mall/tabView.vue"),
      // redirect: { name: "MyDiary" },
      // meta: { title: "商城" },
    },
  ],
};
